import { blue } from "@material-ui/core/colors";

const customTabsStyle = {
  customSwitch: {
    "&.MuiSwitch-root .MuiSwitch-switchBase": {
      color: blue[900]
    },
    "&.MuiSwitch-root .MuiSwitch-switchBase + .MuiSwitch-track": {
      backgroundColor: blue[400]
    },
    "&.MuiSwitch-root .Mui-checked + .MuiSwitch-track": {
      backgroundColor: blue[400]
    },
    "&.MuiSwitch-root .Mui-checked": {
      color: blue[900]
    },
  },
  buttonSearch: {
    display: "flex", 
    justifyContent: "center", 
    alignSelf: 'center' 
  },
  title: {
    display: 'flex', 
    backgroundColor: 'rgb(0, 79, 159)', 
    justifyContent: 'center',
    padding: '6px !important',
  },
  titleText: {
    color: 'white', 
    fontWeight: 'bold !important'
  },
  headerText: {
    color: 'rgb(0, 79, 159)', 
    fontWeight: 'bold !important'
  },
  cell: { 
    backgroundColor: 'white',
    padding: '4px !important'
  },
  tableBackground: {
    margin: '20px',
    backgroundColor: 'rgb(0, 79, 159)'
  },
  tablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '80%'
  }
};

export default customTabsStyle;
